// 获取基础的信息
export const env = state => {
    return {
        from: state.from,
        user: state.bizUser
    }
}

// 获取是否登录
export const isLogin = state => {
    const user = account(state)
    return Boolean(user && user.id)
}

// 获取用户信息
export const account = state => {
    if (state.pageAccountType === 'biz') {
        return state.bizUser
    } else if (state.pageAccountType === 'mis') {
        return state.misUser
    }
    return {}
}




// WEBPACK FOOTER //
// ./src/store/getters.js